import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * Erro no escopo da ação: bloco branco com fio plum à esquerda, dizendo o que falhou, por quê,
 * o que continuou funcionando, e oferecendo a saída. Fica na tela até o usuário resolver ou fechar.
 * Ex.: "Não conseguimos enviar para Yasmin" · "O e-mail não existe. Os outros 2 foram enviados."
 */
export interface ActionErrorProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  description: ReactNode
  /** Saídas: "Corrigir e-mail", "Enviar só por WhatsApp". */
  actions?: ReactNode
  onDismiss?: () => void
}

export function ActionError({
  title,
  description,
  actions,
  onDismiss,
  className,
  ...props
}: ActionErrorProps) {
  return (
    <div
      data-slot="action-error"
      role="alert"
      className={cn(
        'border-plum bg-surface flex items-start justify-between gap-4 border-l-2 px-[18px] py-4',
        className,
      )}
      {...props}
    >
      <div>
        <div className="font-display text-lead text-ink leading-[1.3] font-normal">{title}</div>
        <div className="font-body text-body text-secondary mt-2 font-light">{description}</div>
        {actions ? <div className="mt-3 flex flex-wrap gap-[10px]">{actions}</div> : null}
      </div>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="font-body text-eyebrow text-label hover:text-ink shrink-0 cursor-pointer font-light tracking-normal"
        >
          fechar
        </button>
      ) : null}
    </div>
  )
}
